/* eslint-disable */
//
// Welcome to the annotated FaceTec Device SDK core code for performing secure Liveness Checks!
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { SampleApp } from '../react-ts-liveness';
import Service from '../../services/Service';
import * as FormActions from '../../store/form/actions';
import * as LoaderActions from '../../store/loader/actions';
//
// This is an example self-contained class to perform Liveness Checks with the FaceTec SDK.
// You may choose to further componentize parts of this in your own Apps based on your specific requirements.
//
var LivenessCheckProcessor = /** @class */ (function () {
    function LivenessCheckProcessor(sessionToken, livenessControllerReference, form, step, formInfo, navigate, dispatch, theme, setLoading) {
        var _this = this;
        this.latestNetworkRequest = new XMLHttpRequest();
        //
        // Part 10:  This function gets called after the FaceTec SDK is completely done.  There are no parameters because you have already been passed all data in the processSessionWhileFaceTecSDKWaits function and have already handled all of your own results.
        //
        this.onFaceTecSDKCompletelyDone = function () {
            //
            // DEVELOPER NOTE:  onFaceTecSDKCompletelyDone() is called after you signal the FaceTec SDK with success() or cancel().
            // Calling a custom function on the Sample App Controller is done for demonstration purposes to show you that here is where you get control back from the FaceTec SDK.
            //
            _this.success = _this.latestSessionResult.isCompletelyDone;
            _this.livenessControllerReference.onComplete(_this.latestSessionResult, null, _this.latestNetworkRequest.status);
        };
        //
        // DEVELOPER NOTE:  This public convenience method is for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In your code, you may not even want or need to do this.
        //
        this.isSuccess = function () {
            return _this.success;
        };
        this.form = form;
        this.step = step;
        this.formInfo = formInfo;
        this.navigate = navigate;
        this.dispatch = dispatch;
        this.theme = theme;
        this.setLoading = setLoading;
        //
        // DEVELOPER NOTE:  These properties are for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In the code in your own App, you can pass around signals, flags, intermediates, and results however you would like.
        //
        this.success = false;
        this.livenessControllerReference = livenessControllerReference;
        this.latestSessionResult = null;
        //
        // Part 1:  Starting the FaceTec Session
        //
        // Required parameters:
        // - FaceTecFaceScanProcessor:  A class that implements FaceTecFaceScanProcessor, which handles the FaceScan when the User completes a Session.  In this example, "this" implements the class.
        // - sessionToken:  A valid Session Token you just created by calling your API to get a Session Token from the Server SDK.
        //
        if (window.location !== window.parent.location) {
            new FaceTecSDK.FaceTecSessionFromIFrame(this, sessionToken);
        }
        else {
            new FaceTecSDK.FaceTecSession(this, sessionToken);
        }
    }
    //
    // Part 2:  Handling the Result of a FaceScan
    //
    LivenessCheckProcessor.prototype.processSessionResultWhileFaceTecSDKWaits = function (sessionResult, faceScanResultCallback) {
        var _this = this;
        var _a, _b;
        this.latestSessionResult = sessionResult;
        //
        // Part 3:  Handles early exit scenarios where there is no FaceScan to handle -- i.e. User Cancellation, Timeouts, etc.
        //
        if (sessionResult.status !== FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
            console.log("Session was not completed successfully, cancelling.  Session Status: ".concat(FaceTecSDK.FaceTecSessionStatus[sessionResult.status], ". Code: ").concat(sessionResult.status));
            this.latestNetworkRequest.abort();
            faceScanResultCallback.cancel();
            switch (FaceTecSDK.FaceTecSessionStatus[sessionResult.status]) {
                case "CameraNotEnabled":
                    this.navigate("/", {
                        state: {
                            refresh: true,
                            errorCode: sessionResult.status,
                            errorMessage: "Por favor, permita o acesso da c\u00E2mera. (".concat(FaceTecSDK.FaceTecSessionStatus[sessionResult.status], ")")
                        },
                        replace: true
                    });
                    break;
                case "ContextSwitch":
                    SampleApp.onLivenessCheckPressed(this.form, this.step, this.formInfo, this.theme, this.navigate, this.dispatch, this.setLoading);
                    break;
                case "InitializationNotCompleted":
                    SampleApp.onLivenessCheckPressed(this.form, this.step, this.formInfo, this.theme, this.navigate, this.dispatch, this.setLoading);
                    // this.navigate("/", {
                    //   state: {
                    //     errorCode: sessionResult.status,
                    //     errorMessage: `Ocorreu um erro na execução do liveness. Por favor, tente novamente mais tarde. (${FaceTecSDK.FaceTecSessionStatus[sessionResult.status]})` 
                    //   },
                    //   replace: true
                    // })
                    break;
                case "LockedOut":
                    this.navigate("/", {
                        state: {
                            errorCode: sessionResult.status,
                            errorMessage: "Foram realizadas muitas tentativas em um curto espa\u00E7o de tempo. Por favor, tente novamente mais tarde. (".concat(FaceTecSDK.FaceTecSessionStatus[sessionResult.status], ")")
                        },
                        replace: true
                    });
                    break;
                default:
                    this.navigate("/", {
                        state: {
                            tokenOnboarding: this.formInfo.tokenOnboarding,
                            productName: this.formInfo.productName,
                            countSteps: this.form.countSteps,
                            serviceAlias: this.form.steps[this.form.steps.length - 1].services[0],
                            errorCode: sessionResult.status,
                            errorMessage: "Ocorreu um erro. (".concat((FaceTecSDK.FaceTecSessionStatus[sessionResult.status], sessionResult.status), ")")
                        },
                        replace: true
                    });
            }
            return;
        }
        this.setLoading(false);
        // IMPORTANT:  FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully DOES NOT mean the Liveness Check was Successful.
        // It simply means the User completed the Session and a 3D FaceScan was created.  You still need to perform the Liveness Check on your Servers.
        //
        // Part 4:  Get essential data off the FaceTecSessionResult
        //
        var parameters = {
            faceScan: sessionResult.faceScan,
            auditTrailImage: sessionResult.auditTrail[0],
            lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0],
            sessionId: sessionResult.sessionId
        };
        //NEW FUNCTION
        var newForm = __assign({}, this.form);
        var params = {
            tokenOnboarding: ((_a = this.formInfo) === null || _a === void 0 ? void 0 : _a.tokenOnboarding) || '',
            step: newForm.steps[this.step].step,
            field: "RESULT_LIVENESS_3D",
            value: JSON.stringify(parameters)
        };
        var stepParams = {
            onboardingForm: {
                countSteps: this.form.countSteps,
                steps: [__assign(__assign({}, this.form.steps[this.step]), { services: ["SERVICE_LIVENESS_3D"], fieldsComplete: ["result_liveness_3d", "session_id_liveness_3d", "selfie_liveness_3d"] })],
            },
            tokenOnboarding: ((_b = this.formInfo) === null || _b === void 0 ? void 0 : _b.tokenOnboarding) || '',
        };
        // remove token
        stepParams.onboardingForm.steps[0].fields = stepParams.onboardingForm.steps[0].fields.filter(function (a) { return a.field !== 'token_liveness_3d'; });
        this.dispatch(LoaderActions.show(true));
        Service.serviceField(params)
            .then(function (response) {
            var _a;
            _this.dispatch(LoaderActions.show(false));
            if (response) {
                var scanResult_1 = (_a = response.find(function (item) { return item.field === "result_liveness_3d"; })) === null || _a === void 0 ? void 0 : _a.value;
                if (scanResult_1) {
                    FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage("Liveness\nConfirmada");
                    newForm.steps[_this.step].fields.forEach(function (f, i) {
                        var responseField;
                        switch (f.field) {
                            case "session_id_liveness_3d":
                                newForm.steps[_this.step].fields[i].value = parameters.sessionId;
                                break;
                            case "selfie_liveness_3d":
                                responseField = response.find(function (r) { return r.field === f.field; });
                                newForm.steps[_this.step].fields[i].value = responseField === null || responseField === void 0 ? void 0 : responseField.value;
                                break;
                            case "result_liveness_3d":
                                responseField = response.find(function (r) { return r.field === f.field; });
                                newForm.steps[_this.step].fields[i].value = responseField === null || responseField === void 0 ? void 0 : responseField.value;
                                break;
                        }
                    });
                    _this.dispatch(LoaderActions.show(true));
                    Service.saveStep(stepParams)
                        .then(function (response) {
                        console.log("🚀 ~ liveness ~ response:", response);
                        faceScanResultCallback.proceedToNextStep(scanResult_1 ? scanResult_1 : "");
                        _this.dispatch(LoaderActions.show(false));
                        if (response) {
                            _this.dispatch(FormActions.addFormStep(response));
                            window.setTimeout(function () {
                                var newStep = response.steps[0].step;
                                _this.navigate('/form', { state: { step: newStep } });
                            }, 6000);
                            // navigation.push('Form', { step: step + 1 });
                        }
                        else {
                            //alert('Cadastro concluído com sucesso');
                            // navigation.popToTop();
                        }
                    });
                }
                else {
                    faceScanResultCallback.retry();
                    //this.dispatch(LoaderActions.show(false));
                    //console.log("navigate to form", this.step);
                    //this.navigate('/form', { state: { step: this.step} });
                }
                // navigation.push('Form', { step: step + 1 });
            }
            else {
                // navigation.popToTop();
            }
        })
            .catch(function () {
            //dispatch(LoaderActions.show(false));
            faceScanResultCallback.retry();
        });
        //
        // Part 5:  Make the Networking Call to Your Servers.  Below is just example code, you are free to customize based on how your own API works.
        //
        // this.latestNetworkRequest = new XMLHttpRequest();
        // this.latestNetworkRequest.open("POST", Config.BaseURL + "/liveness-3d");
        // this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
        // this.latestNetworkRequest.setRequestHeader("Authorization", Config.Authorization);
        // this.latestNetworkRequest.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
        // this.latestNetworkRequest.setRequestHeader("X-User-Agent", FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId as string));
        // this.latestNetworkRequest.onreadystatechange = () => {
        //   //
        //   // Part 6:  In our Sample, we evaluate a boolean response and treat true as was successfully processed and should proceed to next step,
        //   // and handle all other responses by cancelling out.
        //   // You may have different paradigms in your own API and are free to customize based on these.
        //   //
        //   if(this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
        //     try {
        //       const responseJSON = JSON.parse(this.latestNetworkRequest.responseText);
        //       console.log("responseJSON",responseJSON);
        //       const scanResultBlob = responseJSON.scanResultBlob;
        //       // In v9.2.0+, we key off a new property called wasProcessed to determine if we successfully processed the Session result on the Server.
        //       // Device SDK UI flow is now driven by the proceedToNextStep function, which should receive the scanResultBlob from the Server SDK response.
        //       if(responseJSON.wasProcessed) {
        //         // Demonstrates dynamically setting the Success Screen Message.
        //         FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage("Liveness\nConfirmada");
        //         // In v9.2.0+, simply pass in scanResultBlob to the proceedToNextStep function to advance the User flow.
        //         // scanResultBlob is a proprietary, encrypted blob that controls the logic for what happens next for the User.
        //         faceScanResultCallback.proceedToNextStep(scanResultBlob);
        //       }
        //       else {
        //         // CASE:  UNEXPECTED response from API.  Our Sample Code keys off a wasProcessed boolean on the root of the JSON object --> You define your own API contracts with yourself and may choose to do something different here based on the error.
        //         console.log("Unexpected API response, cancelling out.");
        //         faceScanResultCallback.cancel();
        //       }
        //     }
        //     catch {
        //       // CASE:  Parsing the response into JSON failed --> You define your own API contracts with yourself and may choose to do something different here based on the error.  Solid server-side code should ensure you don't get to this case.
        //       console.log("Exception while handling API response, cancelling out.");
        //       faceScanResultCallback.cancel();
        //     }
        //   }
        // };
        // this.latestNetworkRequest.onerror = () => {
        //   // CASE:  Network Request itself is erroring --> You define your own API contracts with yourself and may choose to do something different here based on the error.
        //   console.log("XHR error, cancelling.");
        //   faceScanResultCallback.cancel();
        // };
        // //
        // // Part 7:  Demonstrates updating the Progress Bar based on the progress event.
        // //
        // this.latestNetworkRequest.upload.onprogress = (event) => {
        //   var progress = event.loaded / event.total;
        //   faceScanResultCallback.uploadProgress(progress);
        // };
        // //
        // // Part 8:  Actually send the request.
        // //
        // var jsonStringToUpload = JSON.stringify(parameters);
        // this.latestNetworkRequest.send(jsonStringToUpload);
        // //
        // // Part 9:  For better UX, update the User if the upload is taking a while.  You are free to customize and enhance this behavior to your liking.
        // //
        // window.setTimeout( () => {
        //   if(this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
        //     return;
        //   }
        //   faceScanResultCallback.uploadMessageOverride("Realizando upload...");
        // }, 6000);
    };
    return LivenessCheckProcessor;
}());
export { LivenessCheckProcessor };
